import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import ActionTable from "../../components/table/ActionTable";
import api from "../../services/api";
import AppContext from "../../container/context";
import { mergeParams } from "../../helpers/helpers";
import Form from "../../components/form";

export default function Lista({ history, location }) {
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState(
    mergeParams({ nome: "", exibirInativos: false }, location)
  );
  const [lista, setLista] = useState([]);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregarFuncoes();
  }, []);

  const carregarFuncoes = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);

    api
      .get("funcoes/listar", filtrosEnviar)
      .then((res) => {
        setLista(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar funções");
        setCarregando(false);
      });
  };

  const filtros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: dados.nome,
      },
      exibirInativos: {
        label: "Exibir inativos",
        type: "check",
        space: 4,
        value: dados.exibirInativos,
      },
    },

    submit: {
      label: "Buscar",
      action: carregarFuncoes,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirFuncao = (registro) => {
    history.push(`/app/funcao/${registro.id}`);
  };

  const tRegistros = {
    title: "Funções",
    onLineClick: abrirFuncao,
    newItemAction: () => history.push("/app/funcao/0"),
    columns: [
      {
        name: "nome",
        label: "Nome",
      },
      {
        name: "ativo",
        label: "Ativo",
        checkbox: true,
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={filtros} />

      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
